import * as RadixPopover from '@radix-ui/react-popover'
import { forwardRef, type ComponentPropsWithoutRef } from 'react'
import { cn } from '@/lib/cn'

export const Popover = RadixPopover.Root
export const PopoverTrigger = RadixPopover.Trigger
export const PopoverClose = RadixPopover.Close

export const PopoverContent = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<typeof RadixPopover.Content>>(
  function PopoverContent({ className, sideOffset = 8, ...props }, ref) {
    return (
      <RadixPopover.Portal>
        <RadixPopover.Content
          ref={ref}
          sideOffset={sideOffset}
          collisionPadding={12}
          className={cn(
            'glass z-50 rounded-2xl p-4 text-sm shadow-popover outline-none',
            'origin-[var(--radix-popover-content-transform-origin)] data-[state=open]:motion-safe:animate-pop-in data-[state=closed]:motion-safe:animate-pop-out',
            className,
          )}
          {...props}
        />
      </RadixPopover.Portal>
    )
  },
)
